import type { IconProps } from '@quno/patient-journey/src/components/ui/Icon';

const USUKFlag = ({
  getRotation,
  className,
  ...props
}: IconProps): JSX.Element => (
  <svg
    {...props}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="533"
    height="349"
    fill="none"
    viewBox="0 0 533 349"
  >
    <path fill="#BF0A30" d="M532 320H1v28h531v-28z" />
    <path fill="#fff" d="M532 292H1v28h531v-28z" />
    <path fill="#BF0A30" d="M532 264H1v28h531v-28z" />
    <path fill="#fff" d="M532 236H1v28h531v-28z" />
    <path fill="#BF0A30" d="M532 210H1v26h531v-26z" />
    <path fill="#fff" d="M532 184H1v26h531v-26z" />
    <path fill="#BF0A30" d="M532 158H1v26h531v-26z" />
    <path fill="#fff" d="M532 132H1v26h531v-26z" />
    <path fill="#BF0A30" d="M532 106H1v26h531v-26z" />
    <path fill="#fff" d="M532 79H1v27h531V79z" />
    <path fill="#BF0A30" d="M532 53H1v26h531V53z" />
    <path fill="#fff" d="M532 27H1v26h531V27z" />
    <path fill="#BF0A30" d="M532 1H1v26h531V1z" />
    <path fill="#002868" d="M214 1H1v183h213V1z" />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M10 162h6l2-8 3 8h6l-5 6 2 7-6-4-5 5 1-8-4-6zm35 0h6l2-8 3 8h6l-5 6 2 7-6-4-5 5 1-8-4-6zm36 0h6l3-8 2 8h6l-4 6 1 7-5-4-5 5 1-8-5-6zm35 0h6l3-8 2 8h6l-4 6 1 7-5-4-5 5 1-8-5-6zm35 0h6l3-8 2 8h7l-5 6 1 7-5-4-5 5 1-8-5-6zm37 0h6l2-8 3 8h6l-5 6 2 7-6-4-5 5 1-8-4-6zM28 145l6-1 2-7 3 7 6 1-5 5 2 8-5-4-6 4 2-8-5-5zm-18-19 6-1 2-7 3 7 6 1-5 5 2 8-6-4-5 4 1-8-4-5zm18-18h6l2-8 3 7 6 1-5 5 2 8-5-4-6 5 2-8-5-6zM10 89l6-1 2-7 3 7 6 1-5 5 2 8-6-4-5 4 1-8-4-5zm18-17 6-1 2-8 3 8h6l-5 6 2 8-5-4-6 4 2-8-5-5zM10 53l6-1 2-8 3 8h6l-5 6 2 8-6-5-5 5 1-8-4-5zm18-18 6-1 2-7 3 7 6 1-5 5 2 8-5-4-6 4 2-8-5-5zM10 16l6-1 2-7 3 7 6 1-5 5 2 8-6-4-5 4 1-8-4-5zm53 129 6-1 2-7 3 7 6 1-4 5 1 8-5-4-6 4 2-8-5-5zm-18-19 6-1 2-7 3 7 6 1-5 5 2 8-6-4-5 4 1-8-4-5zm18-18h6l2-8 3 7 6 1-4 5 1 8-5-4-6 5 2-8-5-6zM45 89l6-1 2-7 3 7 6 1-5 5 2 8-6-4-5 4 1-8-4-5zm18-17 6-1 2-8 3 8h6l-4 6 1 8-5-4-6 4 2-8-5-5zM45 53l6-1 2-8 3 8h6l-5 6 2 8-6-5-5 5 1-8-4-5zm18-18 6-1 2-7 3 7 6 1-4 5 1 8-5-4-6 4 2-8-5-5zM45 16l6-1 2-7 3 7 6 1-5 5 2 8-6-4-5 4 1-8-4-5zm53 129 6-1 3-7 2 7 6 1-4 5 1 8-5-4-6 4 2-8-5-5zm-17-19 6-1 3-7 2 7 6 1-4 5 1 8-5-4-5 4 1-8-5-5zm70 0 6-1 3-7 2 7 7 1-5 5 1 8-5-4-5 4 1-8-5-5zm-35 0 6-1 3-7 2 7 6 1-4 5 1 8-5-4-5 4 1-8-5-5zm54 19 6-1 2-7 3 7 6 1-5 5 2 8-6-4-5 4 1-8-4-5zm-36 0 7-1 2-7 2 7 7 1-5 5 2 8-6-4-5 4 1-8-5-5zM81 16l6-1 3-7 2 7 6 1-4 5 1 8-5-4-5 4 1-8-5-5zm17 19 6-1 3-7 2 7 6 1-4 5 1 8-5-4-6 4 2-8-5-5zM81 53l6-1 3-8 2 8h6l-4 6 1 8-5-5-5 5 1-8-5-5zm17 19 6-1 3-8 2 8h6l-4 6 1 8-5-4-6 4 2-8-5-5zM81 89l6-1 3-7 2 7 6 1-4 5 1 8-5-4-5 4 1-8-5-5zm17 19h6l3-8 2 7 6 1-4 5 1 8-5-4-6 5 2-8-5-6zm90 18 6-1 2-7 3 7 6 1-5 5 2 8-6-4-5 4 1-8-4-5zm-72-37 6-1 3-7 2 7 6 1-4 5 1 8-5-4-5 4 1-8-5-5zm0-73 6-1 3-7 2 7 6 1-4 5 1 8-5-4-5 4 1-8-5-5zm0 37 6-1 3-8 2 8h6l-4 6 1 8-5-5-5 5 1-8-5-5zm54 55h6l2-8 3 7 6 1-5 5 2 8-6-4-5 5 1-8-4-6zm-36 0h7l2-8 2 7 7 1-5 5 2 8-6-4-5 5 1-8-5-6zm0-73 7-1 2-7 2 7 7 1-5 5 2 8-6-4-5 4 1-8-5-5zm0 37 7-1 2-8 2 8h7l-5 6 2 8-6-4-5 4 1-8-5-5zm54 17 6-1 2-7 3 7 6 1-5 5 2 8-6-4-5 4 1-8-4-5zm-37 0 6-1 3-7 2 7 7 1-5 5 1 8-5-4-5 4 1-8-5-5zm0-73 6-1 3-7 2 7 7 1-5 5 1 8-5-4-5 4 1-8-5-5zm0 37 6-1 3-8 2 8h7l-5 6 1 8-5-5-5 5 1-8-5-5zm37-37 6-1 2-7 3 7 6 1-5 5 2 8-6-4-5 4 1-8-4-5zm-18 19 6-1 2-7 3 7 6 1-5 5 2 8-6-4-5 4 1-8-4-5zm18 18 6-1 2-8 3 8h6l-5 6 2 8-6-5-5 5 1-8-4-5zm-18 19 6-1 2-8 3 8h6l-5 6 2 8-6-4-5 4 1-8-4-5z"
      clipRule="evenodd"
    />
    <path fill="#fff" d="M0 349 535 2l-2 348-533-1z" />
    <path
      fill="#00247D"
      d="M310 348V222h222v126H310zM532 2 351 121h181V2zM1 349l198-129h28l-1 129H1z"
    />
    <path
      fill="#fff"
      d="M533 314v34l-47 3-182-119 2-16 81 2 146 96zm1-314L347 124l58 1 128-84 1-41zM0 347l208-133 22 1v25L66 348l-66-1z"
    />
    <path
      fill="#CF142B"
      d="m0 348 205-132h22l-1 14L45 348H0zm335-130 40 2 158 105-1 22-197-129zm197-15-307-1 102-65 205 1v65z"
    />
    <path fill="#CF142B" d="m294 347 1-187-53 33v155l52-1z" />
    <path stroke="#000" d="M532 1H1v347h531V1z" />
  </svg>
);

export default USUKFlag;
